export default "__VITE_ASSET__VRAku6fjghkApIISiBWPzg__$_?react__"